import React from 'react';
import {
  createFileRoute,
  useParams,
  useNavigate,
} from '@tanstack/react-router';
import { skillRegistry } from '../../../../components/onboarding/registry/SkillRegistry';
import { useSkills } from '../../../../components/onboarding/apis/skill-registry';
import { SettingsLayout } from '../../../../components/Pleri/components/Settings/SettingsLayout';

import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/settings/tools/skill/$skillId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('pleri/pages');
  const { skillId } = useParams({ from: '/settings/tools/skill/$skillId' });
  const navigate = useNavigate();
  const { data: skills } = useSkills();

  const skillState = skills?.find((s) => s.skillType === skillId);
  const isEnabled = skillState?.enabled ?? false;

  // Get skill registration from registry
  const skillRegistration = skillRegistry.getSkill(skillId);

  if (!skillRegistration) {
    return (
      <SettingsLayout>
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="text-center">
            <h2 className="mb-2 text-xl leading-tight font-semibold text-gray-900 dark:text-gray-100">
              {t('skillNotFound')}
            </h2>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              {t('theRequestedSkillConfigurationCouldNotBe')}
            </p>
            <button
              onClick={() => navigate({ to: '/settings/tools' })}
              className="rounded-lg bg-orange-600 px-4 py-2 text-white transition-colors hover:bg-orange-700"
            >
              {t('backToTools')}
            </button>
          </div>
        </div>
      </SettingsLayout>
    );
  }

  const { config: skillConfig, setupComponent: SetupComponent } =
    skillRegistration;

  const handleComplete = async () => {
    navigate({ to: '/settings/tools' });
  };

  const handleCancel = () => {
    navigate({ to: '/settings/tools' });
  };

  return (
    <SettingsLayout>
      <div className="flex h-full flex-col">
        <div className="relative flex-shrink-0">
          {/* Back Button - Floating */}
          <button
            onClick={handleCancel}
            className="absolute top-4 left-4 z-10 inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-100"
          >
            {t('backToToolsArrow')}
          </button>
        </div>

        {/* Configuration Content */}
        <div className="flex-1 overflow-x-hidden overflow-y-auto px-6 py-6">
          <SetupComponent
            skill={{
              ...skillConfig,
              enabled: isEnabled,
              config: skillState?.config,
            }}
            onComplete={handleComplete}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </SettingsLayout>
  );
}
